module.exports = __webpack_public_path__ + "static/media/photo224.8b4028ab.jpg";